import styled from '@emotion/styled'

export const StyleInfoCard = styled.div<any>`
  border-bottom: 1px solid ${(props: any) => props.theme.colors.borderColor};
  padding: 10px;
  cursor: pointer;
`
export const StyleInfoContentWrapper = styled.div`
  flex: 1;
  flex-direction: column;
  row-gap: 6px;
  display: flex;
`
export const StyleInfoTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.borderColor};
  padding-bottom: 5px;
  margin-bottom: 5px;
`
export const StyleLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  height: 50px;
  width: 50px;
  background-color: ${(props: any) => props.theme.colors.primary50};
`
export const StyleNotificationHeader = styled.div<any>`
  padding: 12px;
  border-bottom: 1px solid ${(props) => props.theme.colors.borderColor};
`
